import { Wrapper } from './components/Wrapper';

import type { BoxProps } from '@mui/material';
import type { BoxTypeMap } from '@mui/system';

export const BaseDataRow = <
  D extends React.ElementType = BoxTypeMap['defaultComponent'],
  P = {},
>({
  sx,
  ...props
}: BoxProps<D, P>) => (
  <Wrapper
    sx={{
      gridTemplateColumns: {
        xs: '4fr 1fr auto',
        sm: '4fr repeat(2, 1fr) auto',
        xl: '4fr repeat(2, 1.5fr) auto',
      },
      ...sx,
    }}
    {...props}
  />
);
